import inheritanceConnectorBuilder from './InheritanceConnectorBuilder';
import { buildCanvasAssociationConnectors } from './AssociationConnectorBuilder';

/**
 * Retroactive, whole-canvas pass — the "Find Connectors" button in
 * UmlSchemaImportTab.jsx runs this against whatever is CURRENTLY on the
 * canvas, no new parsing involved. Covers classes/interfaces imported in
 * separate, unrelated pastes that never got linked at import time.
 * Inheritance runs FIRST and its result is folded into existingConnectors
 * before the association pass, so a pair that just became linked by
 * inheritance can't also be picked up as an association in the same run.
 * @param {import('../../Types/UmlShape').default[]} shapes - umlCanvasEngine.shapes (top-level)
 * @param {import('../../Types/UmlConnector').default[]} existingConnectors - umlCanvasEngine.connectors
 * @returns {import('../../Types/UmlConnector').default[]}
 */
export function findCanvasConnectors(shapes, existingConnectors) {
    const inheritanceConnectors = inheritanceConnectorBuilder.buildCanvasInheritanceConnectors(shapes, existingConnectors);
    const associationConnectors = buildCanvasAssociationConnectors(shapes, [...existingConnectors, ...inheritanceConnectors]);
    return [...inheritanceConnectors, ...associationConnectors];
}
